/* eslint-disable react/jsx-no-target-blank */
import { useFilter } from '../../FilterContext'
import { useParams } from 'react-router-dom'
import clsx from 'clsx'
import SearchInputGroup from '../../components/SearchInputGroup';
import DatePickerFilter from '../../settlement/components/DatePickerFilter';
import { zonedTimeToUtc } from 'date-fns-tz';
import { endOfDay } from 'date-fns';
// import DatePickerFilterSingle from '../components/SingleDatePickerFilter';
import SingleSelection from '../../components/SingleSelection';

interface SelectType {
  readonly value: string;
  readonly label: string;
}

export function CreditFilter() {
  const params = useParams()
  const { globalFilter, setGlobalFilter } = useFilter()

  const creditStatusOptions: SelectType[] = [
    { value: 'SUBMITTED', label: 'Submitted' },
    { value: 'DECLINED', label: 'Declined' },
    { value: 'EXPIRED', label: 'Expired' },
    { value: 'CREDITED', label: 'Credited' },
    { value: 'DUPLICATED_CASE', label: 'Duplicated Case' },
  ];

  const selectedCreditStatusValues = globalFilter?.ethocaCreditsList?.status?.values as SelectType[] | undefined;
  const selectedCreditStatus =
    selectedCreditStatusValues?.some(
      (status) => status?.value === 'SUBMITTED' || status?.value === 'APPROVED'
    )
      ? { value: 'SUBMITTED', label: 'Submitted' }
      : selectedCreditStatusValues?.[0];

  return (
    <div className='mb-4'>
      <div className={(clsx('justify-content-between', params.id ? 'blur' : ''))}>
        <div className='d-flex'>
          <DatePickerFilter
            onChange={(selectedDate) =>
              setGlobalFilter({
                ...globalFilter,
                ethocaCreditsList: {
                  ...globalFilter.ethocaCreditsList,
                  'credit.merchant_request_date': selectedDate && {
                    from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                    to: zonedTimeToUtc(
                      new Date(endOfDay(selectedDate.end)),
                      'Hongkong'
                    ).toISOString(),
                  },
                },
              })
            }
            label='Request Date'
            placeholder='Filter Request Date...'
            className='me-6'
          />

          <SingleSelection
            title={'Credit Status'}
            globalFilterValue={selectedCreditStatus}
            options={creditStatusOptions}
            isClearable
            onChange={(e) => {
              const statusValues =
                e?.value === 'SUBMITTED'
                  ? [
                    { value: 'SUBMITTED', label: 'Submitted' },
                    { value: 'APPROVED', label: 'Approved' },
                  ]
                  : typeof e?.value === 'string'
                    ? [e]
                    : undefined;

              setGlobalFilter({
                ...globalFilter,
                ethocaCreditsList: {
                  ...globalFilter?.ethocaCreditsList,
                  'status': statusValues ? { type: 'in', values: statusValues } : undefined,
                },
              });
            }}
            className='min-w-175px'
          />

          {/* Search */}
          <SearchInputGroup
            inputs={[ // key = filter key
              { key: 'arn', title: 'ARN' },
              { key: 'cases.id', title: 'Case ID' },
              { key: 'direct_merchant_id', title: 'Client ID' },
            ]}
            section='ethocaCreditsList' // globalFilter section key
            globalFilterValue={globalFilter}
            onSubmit={(searchValues) => setGlobalFilter({ ...globalFilter, ethocaCreditsList: { ...globalFilter.ethocaCreditsList, ...searchValues } })}
            onClear={(searchValues) => setGlobalFilter({ ...globalFilter, ethocaCreditsList: { ...globalFilter.ethocaCreditsList, ...searchValues } })}
          />
        </div>
      </div>
    </div>
  )
}
